module.exports = __webpack_public_path__ + "img/title-2.3557a9ca.png";